import { useCallback, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { assetUrl } from "../lib/api";

export const Lightbox = ({ images, index, onIndex, onClose, name }) => {
  const { t } = useTranslation();
  const touch = useRef(null);
  const open = index !== null && index >= 0;
  const go = useCallback((d) => onIndex((index + d + images.length) % images.length), [index, images.length, onIndex]);
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "ArrowRight") go(document.dir === "rtl" ? -1 : 1);
      if (e.key === "ArrowLeft") go(document.dir === "rtl" ? 1 : -1);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, go]);
  if (!open) return null;
  const img = images[index];
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-6xl w-[96vw] p-0 bg-[#0d0b09] border-none rounded-2xl overflow-hidden [&>button]:hidden" data-testid="lightbox">
        <DialogTitle className="sr-only">{t("memorial.photo_of", { name })}</DialogTitle>
        <div
          className="relative h-[82vh] grid place-items-center"
          onTouchStart={(e) => (touch.current = e.touches[0].clientX)}
          onTouchEnd={(e) => {
            const dx = e.changedTouches[0].clientX - (touch.current || 0);
            if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
          }}
        >
          <img src={assetUrl(img.full)} alt={t("memorial.photo_of", { name })} className="max-h-full max-w-full object-contain" data-testid="lightbox-image" />
          <button onClick={onClose} className="hud-btn absolute top-4 end-4" aria-label={t("common.close")} data-testid="lightbox-close-btn"><X size={18} /></button>
          {images.length > 1 && (
            <>
              <button onClick={() => go(-1)} className="hud-btn absolute start-4 top-1/2 -translate-y-1/2" aria-label={t("memorial.prev")} data-testid="lightbox-prev-btn"><ChevronLeft size={20} className="flip-rtl" /></button>
              <button onClick={() => go(1)} className="hud-btn absolute end-4 top-1/2 -translate-y-1/2" aria-label={t("memorial.next")} data-testid="lightbox-next-btn"><ChevronRight size={20} className="flip-rtl" /></button>
            </>
          )}
          {img.caption && <p className="absolute bottom-10 inset-x-6 text-center font-heading italic text-lg text-white/90 [text-shadow:0_1px_8px_rgba(0,0,0,0.8)]" dir="auto" data-testid="lightbox-caption">{img.caption}</p>}
          <p className="absolute bottom-4 text-xs text-white/60" data-testid="lightbox-counter">{index + 1} / {images.length}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
